module.exports = __webpack_public_path__ + "img/7.fdfd1fd3.jpg";